export default {"src":"/_next/static/media/signupBanner.e89a4bc6.svg","height":360,"width":550,"blurWidth":0,"blurHeight":0};